import { ChevronRightIcon } from 'lucide-react-native';
import React from 'react';
import { View } from 'react-native';
import { ListItem } from '../../Core/List/ListItem';
import { IconProps } from '../../Icons/Icons.types';

export type PortfolioListItemType = {
  iconComponent: React.ElementType;
  iconProps?: IconProps;
  assetColumn?: React.ReactNode;
  holdingsColumn?: React.ReactNode;
  returnsColumn?: React.ReactNode;
  weightingColumn?: React.ReactNode;
  //on mobile we will use this one for the right end column
  actionsColumn?: React.ReactNode;
  pendingAction?: React.ReactNode;
  isPressable?: boolean;
  onPress?: () => void;
  isMobile?: boolean;
  className?: string;
  showChevron: boolean;
};

export const PortfolioListItem = ({
  iconComponent: IconComponent,
  iconProps,
  assetColumn,
  holdingsColumn,
  returnsColumn,
  weightingColumn,
  actionsColumn,
  pendingAction,
  isPressable,
  onPress,
  isMobile,
  className,
  showChevron = false,
}: PortfolioListItemType) => {
  return (
    <ListItem
      onPress={() => onPress?.()}
      className={className}
      pressable={isPressable ?? onPress !== undefined}>
      {isMobile ? (
        <View className="w-full flex flex-col gap-2">
          <View className="w-full flex-row">
            <View className="w-1/2 flex-row justify-start gap-4 items-center">
              <IconComponent {...iconProps} width={30} />
              {assetColumn}
            </View>
            <View className="w-1/2">{actionsColumn}</View>
          </View>
          {pendingAction}
        </View>
      ) : (
        <View className="w-full flex flex-row gap-4">
          <View className="flex-row items-center justify-start gap-4 flex-[2]">
            <IconComponent {...iconProps} width={30} />
            {assetColumn}
          </View>
          <View className="flex items-end justify-center flex-[2]">
            {holdingsColumn}
          </View>
          <View className="flex items-end justify-center flex-1">
            {returnsColumn}
          </View>
          <View className="flex items-end justify-center flex-1">
            {weightingColumn}
          </View>
          <View className="flex-row items-center justify-end gap-4 flex-[3]">
            {actionsColumn}
            {showChevron && (
              <ChevronRightIcon className="text-white flex-shrink-0" />
            )}
          </View>
        </View>
      )}
    </ListItem>
  );
};
